import styled from 'styled-components'
import {ModalBackgroundStyleProps, ModalStyleProps} from './ModalProps'

export const ModalBackground = styled.div<ModalBackgroundStyleProps & {zIndex?: number}>`
  position: fixed;
  inset: 0px;
  z-index: ${({zIndex}) => (zIndex != null ? zIndex - 1 : 'auto')};
  background-color: ${({bgBackgroundColor, theme}) => bgBackgroundColor ?? theme.modal?.bgBackgroundColor ?? 'rgba(0, 0, 0, 0.7)'};
`

export const ModalContainer = styled.div<ModalStyleProps>`
  width: ${({width}) => width ?? 'fit-content'};
  min-width: ${({minWidth}) => minWidth};

  height: ${({height}) => height ?? 'fit-content'};
  min-height: ${({minHeight}) => minHeight};

  position: fixed;
  z-index: ${({zIndex}) => zIndex ?? 9};
  ${({isLateral}) => (isLateral ? 'top: 0%; right: 0%;' : 'top: 50%; left: 50%; transform: translate(-50%, -50%);')}

  background-color: ${({backgroundColor, theme}) => backgroundColor ?? theme.modal?.backgroundColor ?? 'inherit'};

  border-color: ${({borderColor, theme}) => borderColor ?? theme.modal?.borderColor ?? null};
  border-radius: ${({borderRadius, theme}) => borderRadius ?? theme.modal?.borderRadius ?? 'inherit'};

  box-shadow: ${({boxShadow, theme}) => boxShadow ?? theme.modal?.boxShadow ?? null};

  margin: ${({margin, theme}) => margin ?? theme.modal?.margin ?? null};
  margin-top: ${({marginTop, theme}) => marginTop ?? theme.modal?.marginTop ?? null};
  margin-left: ${({marginLeft, theme}) => marginLeft ?? theme.modal?.marginLeft ?? null};
  margin-right: ${({marginRight, theme}) => marginRight ?? theme.modal?.marginRight ?? null};
  margin-bottom: ${({marginBottom, theme}) => marginBottom ?? theme.modal?.marginBottom ?? null};
  padding: 0;
  @media (max-width: 1400px) {
    ${({isLateral}) => !isLateral && 'min-height: 400px;'};
    ${({isLateral}) => !isLateral && 'max-height: 670px;'};
  }

  @media (max-width: 1200px) {
    width: 70%;
  }
  @media (max-width: 1000px) {
    width: 80%;
  }

  @media (max-width: 400px) {
    width: 100%;
  }
`
